import { Typography } from "@material-ui/core"


const Lyrics = (props) => {

  return ( <>
    <Typography>
      Fast! When you make your purchase, you’ll schedule a video chat with one of our lyricists. Once we have that chat and get all the juicy details, we’ll deliver the first draft of your lyrics within 48 hours. That means in just two days, you’ll have a custom song in the making—faster than most people decide what to watch on Netflix.
    </Typography>
  </> )
}

export default Lyrics
